import type { ReactNode, Ref } from 'react';
import { clsx } from 'clsx';
import { BaseLink, type BaseLinkProps } from '../link/base-link';
import { type ButtonAffixIconPosition, type ButtonAppearance, ButtonContent, type ButtonSize, type ButtonState, type ButtonVariant } from './shared';
import styles from './button.module.scss';

export interface ButtonLinkProps extends Omit<BaseLinkProps, 'state'> {
  affixIcon?: ReactNode;
  affixIconPosition?: ButtonAffixIconPosition;
  appearance?: ButtonAppearance;
  fullWidth?: boolean;
  linkState?: BaseLinkProps['state'];
  ref?: Ref<HTMLAnchorElement>;
  size?: ButtonSize;
  state?: ButtonState;
  variant?: ButtonVariant;
}

export function ButtonLink({
  affixIcon,
  affixIconPosition = 'left',
  appearance,
  className,
  children,
  fullWidth,
  linkState,
  ref,
  size = 'medium',
  state = 'initial',
  variant = 'primary',
  ...rest
}: ButtonLinkProps) {
  return (
    <BaseLink
      className={clsx(
        styles.button,
        styles[`appearance-${appearance}`],
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        styles[`state-${state}`],
        Boolean(affixIcon) && styles[`affix-${affixIconPosition}`],
        Boolean(affixIcon && !children) && styles.iconOnly,
        fullWidth && styles.fullWidth,
        className,
      )}
      ref={ref}
      state={linkState}
      {...rest}
    >
      <ButtonContent affixIcon={affixIcon} affixIconPosition={affixIconPosition} state={state}>
        {children}
      </ButtonContent>
    </BaseLink>
  );
}
